import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import { Quad } from '@marmon/shared/types/quad';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-quad-margin-percent-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class QuadMarginPercentCellComponent extends ColorCodeCellBase<number> {
	readonly toValue = inject(PercentToValuePipe);

	override readonly formattedValue = computed(() =>
		this.toValue.transform(this.value()),
	);

	readonly box = input.required<Quad>();
	readonly quad1MarginPercent = input.required<number>();

	override getColorCode(value: number): CellColorCode {
		const quad = this.box() - 1;
		const quad1MarginPercent = this.quad1MarginPercent();

		if (quad === 0) return 'gray';
		const target =
			quad === 3 ? quad1MarginPercent + 0.15 : quad1MarginPercent + 0.07;
		const delta = value - target;
		const warningThreshold = quad === 3 ? -0.05 : -0.02;
		if (delta >= 0) return 'green';
		if (delta >= warningThreshold) return 'yellow';
		return 'red';
	}
}
